import SubMenuList from "../../../resusable/SubMenuList";

const subMenuData = [
  {
    subMenu: [
      {
        title: `Web Services / Web Development`,
        to: "/services",
        id: 1,
      },
      {
        title: "Enterprise Applications",
        to: "/services",
        id: 2,
      },
      {
        title: `Cloud Computing Services`,
        to: "/services",
        id: 3,
      },
      {
        title: "Mobile Development",
        to: "/services",
        id: 4,
      },
      {
        title: `Quality Assurance (QA) and Testing`,
        to: "/services",
        id: 5,
      },
      {
        title: `Maintenance and Support`,
        to: "/services",
        id: 1,
      },
    ],
    heading: "Custom Software Development",
    description:
      "create scalable, secure applications that streamline operations, enhance productivity",
    id: 11,
  },
  {
    subMenu: [
      {
        title: `Software Consulting`,
        to: "/services",
        id: 1,
      },
      {
        title: `Cloud Computing Services`,
        to: "/services",
        id: 2,
      },
      {
        title: `IT Infra Management`,
        to: "/services",
        id: 3,
      },
      {
        title: `Training and Support`,
        to: "/services",
        id: 4,
      },
      {
        title: `Big Data and Analytics`,
        to: "/services",
        id: 5,
      },
      {
        title: `IT Support and Helpdesk`,
        to: "/services",
        id: 1,
      },
      {
        title: `CI/CD & DevOps Services`,
        to: "/services",
        id: 1,
      },
    ],
    heading: `IT Consulting Services`,
    id: 22,
  },
  {
    subMenu: [
      {
        title: `Data centre services`,
        to: "/services",
        id: 1,
      },
      {
        title: `System Administration`,
        to: "/services",
        id: 2,
      },
      {
        title: `Product Management`,
        to: "/services",
        id: 3,
      }
    ],
    heading: "Research & Development",
    id: 33,
  },
  {
    subMenu: [
      {
        title: `Digital Marketing`,
        to: "/services",
        id: 1,
      },
      {
        title: `Search Engine Optimization (SEO)`,
        to: "/services",
        id: 2,
      },
      {
        title: `E-Mail Marketing`,
        to: "/services",
        id: 3,
      },
      {
        title: "Social Media Marketing",
        to: "/services",
        id: 4,
      },
    ],
    heading: `Advertisement and Promotion Services`,
    id: 44,
  },
  {
    subMenu: [
      {
        title: `UI/UX Design`,
        to: "/services",
        id: 1,
      },
      {
        title: `Graphic Designing`,
        to: "/services",
        id: 2,
      }
    ],
    heading: `UI/UX Services`,
    id: 55,
  },
];

// const subMenuDataRowTwo = [
//   {
//     subMenu: [
//       {
//         title: "Web Development",
//         to: "/services",
//         id: 1,
//       },
//       {
//         title: "Digital Marketing",
//         to: "/services",
//         id: 2,
//       },
//       {
//         title: "SEO Marketing",
//         to: "services",
//         id: 3,
//       },
//       {
//         title: "Mobile Development",
//         to: "services",
//         id: 4,
//       },
//       {
//         title: "Graphic Designing",
//         to: "services",
//         id: 5,
//       },
//       {
//         title: "Cloud Services",
//         to: "services",
//         id: 1,
//       },
//     ],
//     heading: "Advertisement and Promotion",
//     id: 66,
//   },
//   {
//     subMenu: [
//       {
//         title: "Web Development",
//         to: "/services",
//         id: 1,
//       },
//       {
//         title: "Digital Marketing",
//         to: "/services",
//         id: 2,
//       },
//       {
//         title: "SEO Marketing",
//         to: "services",
//         id: 3,
//       },
//       {
//         title: "Mobile Development",
//         to: "services",
//         id: 4,
//       },
//       {
//         title: "Graphic Designing",
//         to: "services",
//         id: 5,
//       },
//       {
//         title: "Cloud Services",
//         to: "services",
//         id: 1,
//       },
//     ],
//     heading: "IT Infra Management",
//     id: 77,
//   },
//   {
//     subMenu: [
//       {
//         title: "Web Development",
//         to: "/services",
//         id: 1,
//       },
//       {
//         title: "Digital Marketing",
//         to: "/services",
//         id: 2,
//       },
//       {
//         title: "SEO Marketing",
//         to: "services",
//         id: 3,
//       },
//       {
//         title: "Mobile Development",
//         to: "services",
//         id: 4,
//       },
//       {
//         title: "Graphic Designing",
//         to: "services",
//         id: 5,
//       },
//       {
//         title: "Cloud Services",
//         to: "services",
//         id: 1,
//       },
//     ],
//     heading: "Training and Support",
//     id: 88,
//   },
//   {
//     subMenu: [
//       {
//         title: "Web Development",
//         to: "/services",
//         id: 1,
//       },
//       {
//         title: "Digital Marketing",
//         to: "/services",
//         id: 2,
//       },
//       {
//         title: "SEO Marketing",
//         to: "services",
//         id: 3,
//       },
//       {
//         title: "Mobile Development",
//         to: "services",
//         id: 4,
//       },
//       {
//         title: "Graphic Designing",
//         to: "services",
//         id: 5,
//       },
//       {
//         title: "Cloud Services",
//         to: "services",
//         id: 1,
//       },
//     ],
//     heading: "Online Courses",
//     id: 99,
//   },
// ];

function ServiceMenu() {
  return (
    <>
      <SubMenuList data={subMenuData} />
      {/* <div className="dropdown-divider"></div>
      <SubMenuList data={subMenuDataRowTwo} maxWidth="maxWidth" /> */}
    </>
  );
}

export default ServiceMenu;
